module.exports = __webpack_public_path__ + "img/in-blanco.8f4fe2eb.png";